export { default as highlightTermsInHtmlElement } from './utils/highlightTermsInHtmlElement';
